import { Mark } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { USERROLE } from "../../../utils/commonConstant";

let trackChangePersonName = USERROLE.ADMIN;
export const Comment = Mark.create({
  name: "comment",

  addOptions() {
    return {
      HTMLAttributes: {
        class: "comment-mark",
      },
      handleSave: null,
    };
  },

  addAttributes() {
    return {
      commentId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-comment-id"),
        renderHTML: (attributes) => ({
          "data-comment-id": attributes.commentId,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-comment-id]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", HTMLAttributes, 0];
  },
});

// Helper function to create comment UI
function createCommentUI(comment, extension, view, comments, handleSave) {
  console.log("createCommentUI invoked");
  console.log(comment);
  console.log(extension);
  console.log(view);
  console.log(comments);
  const container = document.createElement("div");
  container.className = "comment-container";

  // Comment input/display area
  const commentArea = document.createElement("div");
  commentArea.className = "comment-area";

  function renderComments() {
    // Clear existing comments
    commentArea.innerHTML = "";

    // Show existing comments if any
    if (comment.threads && comment.threads.length > 0) {
      comment.threads.forEach((thread) => {
        const threadEl = document.createElement("div");
        threadEl.className = "comment-thread";

        const authorInfo = document.createElement("div");
        authorInfo.className = "author-info";
        authorInfo.textContent = `${thread.name}`;

        const commentText = document.createElement("div");
        commentText.className = "comment-text";
        commentText.textContent = thread.content;

        const timestamp = document.createElement("div");
        timestamp.className = "timestamp";
        timestamp.textContent = new Date(thread.timestamp).toLocaleString();

        threadEl.appendChild(authorInfo);
        threadEl.appendChild(commentText);
        threadEl.appendChild(timestamp);
        commentArea.appendChild(threadEl);
      });
    }
  }

  renderComments();

  // New comment input
  const input = document.createElement("textarea");
  input.className = "comment-input";
  input.placeholder = "Add a comment...";

  // Save button
  const saveButton = document.createElement("button");
  saveButton.className = "save-comment-button";
  saveButton.textContent = "Save";
  saveButton.onclick = () => {
    if (!input.value.trim()) return;
    const userId = localStorage.getItem("UserId");
    const name = localStorage.getItem("Name");
    const newThread = {
      id: `thread-${Date.now()}`,
      content: input.value,
      userId: userId,
      name: name,
      timestamp: Date.now(),
    };

    if (!comment.threads) {
      comment.threads = [];
    }
    comment.threads.push(newThread);

    // Apply highlight when first comment is saved
    if (comment.threads.length === 1) {
      const { from, to } = comment;
      const tr = view.state.tr.addMark(
        from,
        to,
        view.state.schema.marks.selectionHighlight.create({
          id: comment.highlightId,
          commentId: comment.id,
          hasComments: true, // Make sure this is being set
          class: "selection-highlight", // Add this line
          highlightStatus: "Pending", //Added highlightStatus for status of comment new
        })
      );
      view.dispatch(tr);
    }

    // Update comment in storage
    comments.set(comment.id, comment);
    extension.storage.comments = comments;

    // Trigger callback
    extension.options.onCommentUpdate(comment);

    // Clear input
    input.value = "";

    // Refresh comments display
    renderComments();
    handleSave(true);
  };

  const resolvedButton = document.createElement("button");
  resolvedButton.className = "resolved-comment-button";
  resolvedButton.textContent = "Resolved";
  resolvedButton.onclick = () => {
    // Remove comment from storage
    comments.delete(comment.id);
    extension.storage.comments = comments;

    // Remove highlight mark
    const { from, to } = comment;
    const tr = view.state.tr.removeMark(
      from,
      to,
      view.state.schema.marks.selectionHighlight
    );
    view.dispatch(tr);

    // Trigger callback
    extension.options.onCommentDelete(comment);
    const commentClass = document.querySelectorAll(".selection-highlight");
    console.log(commentClass, "commentClass From Extension");
    if (commentClass.length === 0) {
      extension.options.highlightContext.setAcceptReject({
        accept: false,
        reject: true,
      });
    }

    handleSave(true);
    // Remove UI
    container.remove();
  };

  // Accept button
  const acceptButton = document.createElement("button");
  acceptButton.className = "accept-comment-button";
  acceptButton.textContent = "Accept";
  acceptButton.onclick = () => {
    // Implement the accept functionality here
    const { from, to } = comment;
    const tr = view.state.tr.removeMark(
      from,
      to,
      view.state.schema.marks.selectionHighlight
    );
    view.dispatch(tr);
    // Trigger callback
    extension.options.onCommentDelete(comment);
    console.log("Accept button clicked");
    // const commentClass = document.querySelectorAll(".selection-highlight");
    // console.log(commentClass, "commentClass From Extension");
    // if (commentClass.length === 0) {
    //   extension.options.highlightContext.setAcceptReject({
    //     accept: false,
    //     reject: true,
    //   });
    // }
    handleSave(true);
    // Remove UI
    container.remove();
  };

  // Reject button
  const rejectButton = document.createElement("button");
  rejectButton.className = "reject-comment-button";
  rejectButton.textContent = "Reject";
  rejectButton.onclick = () => {
    // Implement the reject functionality here
    console.log("Reject button clicked");
    const { from, to, threads } = comment;
    if (threads.length > 0) {
      const tr = view.state.tr.addMark(
        from,
        to,
        view.state.schema.marks.selectionHighlight.create({
          id: comment.highlightId,
          commentId: comment.id,
          hasComments: true,
          class: "selection-highlight",
          highlightStatus: "Rejected", // Add rejected status
        })
      );
      view.dispatch(tr);
      // const commentClass = document.querySelectorAll(".selection-highlight");
      // if (commentClass.length > 0) {
      //   extension.options.highlightContext.setAcceptReject({
      //     accept: true,
      //     reject: false,
      //   });
      // }
    }

    handleSave(true);
    // Remove UI
    container.remove();
  };

  // Close button
  const closeButton = document.createElement("button");
  closeButton.className = "close-comment-button";
  closeButton.textContent = "×";
  closeButton.onclick = () => {
    container.remove();
  };

  const buttonContainer = document.createElement("div");
  buttonContainer.className = "button-container";
  buttonContainer.appendChild(acceptButton);
  buttonContainer.appendChild(rejectButton);
  // Assemble UI
  const inputContainer = document.createElement("div");
  inputContainer.className = "input-container";
  inputContainer.appendChild(input);
  inputContainer.appendChild(saveButton);
  // inputContainer.appendChild(resolvedButton)
  inputContainer.appendChild(buttonContainer);
  container.appendChild(closeButton);
  container.appendChild(commentArea);
  container.appendChild(inputContainer);

  return container;
}

export const SelectionHighlight = Mark.create({
  name: "selectionHighlight",

  addOptions() {
    return {
      HTMLAttributes: {
        class: "selection-highlight",
      },
      highlightClass: "selection-highlight",
      onHighlight: () => { },
      onCommentCreate: () => { },
      onCommentUpdate: () => { },
      onCommentDelete: () => { },
      comments: [],
    };
  },

  addStorage() {
    const defaultComments = this.options.comments;
    const comments = new Map();

    // Populate the comments map from the defaultComments array
    if (Array.isArray(defaultComments)) {
      // Populate the comments map from the array
      defaultComments.forEach(([key, comment]) => {
        comments.set(key, comment);
      });
    }

    return {
      comments: comments,
    };
  },

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-highlight-id"),
        renderHTML: (attributes) => ({
          "data-highlight-id": attributes.id,
        }),
      },
      commentId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-comment-id"),
        renderHTML: (attributes) => ({
          "data-comment-id": attributes.commentId,
        }),
      },
      hasComments: {
        default: false,
        parseHTML: (element) =>
          element.getAttribute("data-has-comments") === "true",
        renderHTML: (attributes) => ({
          "data-has-comments": attributes.hasComments,
        }),
      },
      highlightStatus: {
        default: false,
        parseHTML: (element) => element.getAttribute("data-highlight-status"),
        renderHTML: (attributes) => ({
          "data-highlight-status": attributes.highlightStatus,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-highlight-id]",
      },
    ];
  },

  // Modified version for debugging
  renderHTML({ HTMLAttributes }) {
    const attrs = { ...HTMLAttributes };
    // Always ensure the base class is present
    attrs.class = attrs.class || "";
    if (!attrs.class.includes("selection-highlight")) {
      attrs.class = `selection-highlight ${attrs.class}`.trim();
    }
    if (attrs.hasComments) {
      attrs.class = `${attrs.class} has-comments`.trim();
    }
    if (attrs.highlightStatus) {
      attrs.class = `${attrs.class} highlight-status`.trim();
    }
    console.log("Rendered attributes:", attrs);
    return ["span", attrs, 0];
  },

  addCommands() {
    return {
      setHighlight:
        (id) =>
          ({ commands }) => {
            return commands.setMark(this.name, { id });
          },
      removeHighlight:
        () =>
          ({ commands }) => {
            return commands.unsetMark(this.name);
          },
      unsetHighlight:
        () =>
          ({ commands }) => {
            return commands.unsetMark(this.name);
          },
      setComment:
        (highlightId, commentId) =>
          ({ commands }) => {
            return commands.updateAttributes(this.name, {
              id: highlightId,
              commentId: commentId,
              hasComments: true,
              highlightStatus: "Pending",
            });
          },
      removeComment:
        (highlightId) =>
          ({ commands }) => {
            return commands.updateAttributes(this.name, {
              id: highlightId,
              commentId: null,
              hasComments: false,
              highlightStatus: "Accepted",
            });
          },
    };
  },

  addProseMirrorPlugins() {
    const pluginKey = new PluginKey("selectionHighlight");
    const extension = this;

    return [
      new Plugin({
        key: pluginKey,

        state: {
          init() {
            return {
              decorationSet: DecorationSet.empty,
              comments: extension.storage.comments,
              activeHighlight: null,
            };
          },
          apply(tr, pluginState) {
            const { selection } = tr;
            let { decorationSet, comments, activeHighlight } = pluginState;

            if (
              extension?.options?.isHighlightPluginEnabled &&
              trackChangePersonName === USERROLE.ADMIN
            ) {
              return pluginState;
            }
            // Handle comment updates if any
            if (tr.docChanged) {
              const newComments = new Map(comments);
              tr.mapping.maps.forEach((map, i) => {
                newComments.forEach((comment, id) => {
                  const newPos = map.map(comment.pos);
                  if (newPos !== comment.pos) {
                    newComments.set(id, { ...comment, pos: newPos });
                    extension.storage.comments = newComments;
                  }
                });
              });
              comments = newComments;
            }

            if (selection.empty) {
              return {
                decorationSet: DecorationSet.empty,
                comments,
                activeHighlight: null,
              };
            }

            const from = selection.from;
            const to = selection.to;

            if (from !== to) {
              const decorations = [];
              const decoration = Decoration.widget(
                to,
                (view) => {
                  // Prevent showing the comment button if selection contains an image node
                  let hasImage = false;
                  view.state.doc.nodesBetween(from, to, (node) => {
                    if (node.type.name === "image") {
                      hasImage = true;
                      return false;
                    }
                  });
                  if (hasImage) {
                    return document.createTextNode("");
                  }
                  const button = document.createElement("button");
                  button.className = "add-comment-button";

                  if (trackChangePersonName !== USERROLE.SUBCONTRACTOR) {
                    button.textContent = "💬";
                    const selection = window.getSelection();
                    if (selection.rangeCount > 0) {
                      const range = selection.getRangeAt(0);
                      const rect = range.getBoundingClientRect();
                      button.style.position = "relative";
                      button.style.zIndex = "999999999";
                      button.style.left = `10px`;
                      button.style.top = `5px`;
                    }
                  } else {
                    button.style.display = "none";
                  }

                  button.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const { from: latestFrom, to: latestTo } =
                      view.state.selection;
                    const highlightId = `highlight-${Date.now()}`;
                    const commentId = `comment-${Date.now()}`;

                    const comment = {
                      id: commentId,
                      highlightId,
                      from: latestFrom,
                      to: latestTo,
                      text: view.state.doc.textBetween(latestFrom, latestTo),
                      threads: [],
                    };
                    comments.set(commentId, comment);
                    extension.storage.comments = comments;

                    const commentUI = createCommentUI(
                      comment,
                      extension,
                      view,
                      comments,
                      extension.options.handleSave
                    );
                    document.body.appendChild(commentUI);

                    const selection = window.getSelection();
                    if (selection.rangeCount > 0) {
                      const range = selection.getRangeAt(0);
                      const rect = range.getBoundingClientRect();
                      commentUI.style.position = "fixed";
                      commentUI.style.left = `${rect.right + 10}px`;
                      commentUI.style.top = `${rect.top}px`;
                    }

                    extension.options.onCommentCreate(comment);
                  });

                  return button;
                },
                { key: "comment-button" }
              );

              decorations.push(decoration);
              decorationSet = DecorationSet.create(tr.doc, decorations);
            }

            return {
              decorationSet,
              comments,
              activeHighlight,
            };
          },
        },

        props: {
          decorations(state) {
            return this.getState(state).decorationSet;
          },
          handleClick(view, pos, event) {
            console.log("First From  comment hightlist");
            const { trackChangeDisplayBy, highlightContext } =
              extension.options;
            console.log(highlightContext, "highlightContext comment hightlist");
            console.log(
              trackChangeDisplayBy,
              "trackChangeBy comment hightlist"
            );
            trackChangePersonName =
              trackChangeDisplayBy ?? trackChangePersonName;
            if (trackChangeDisplayBy === USERROLE.SUBCONTRACTOR) {
              return false;
            }
            const { state } = view;
            const { schema } = state;
            const { marks } = schema;

            // Debug: Check if the mark type exists
            const highlightMark = marks.selectionHighlight;
            console.log("Available mark types:", Object.keys(marks));
            console.log("Highlight mark type:", highlightMark);

            const start = pos;
            const end = pos; //state.doc.content.size

            // Debug: Log the examined range
            console.log("Examining range:", start, end);
            console.log("Text in range:", state.doc.textBetween(start, end));

            let foundMark = null;
            state.doc.nodesBetween(start, end, (node, pos) => {
              // Debug: Log each node we're checking
              console.log("Checking node:", node.type.name, "at pos:", pos);
              console.log(
                "Node marks:",
                node.marks.map((m) => m.type.name)
              );

              if (node.marks.length > 0) {
                // Try both direct comparison and name-based comparison
                const mark = node.marks.find(
                  (m) =>
                    m.type === marks.selectionHighlight ||
                    m.type.name === "selectionHighlight"
                );
                if (mark) {
                  console.log("Found mark:", mark);
                  foundMark = mark;
                  return false;
                }
              }
            });

            if (!foundMark) {
              console.log("No mark found in range");
              return false;
            }

            if (foundMark) {
              const { commentId } = foundMark.attrs;
              const comment = this.getState(state).comments.get(commentId);

              if (comment) {
                // Remove any existing comment UI before creating a new one
                const existingUI = document.querySelector(".comment-container");
                if (existingUI) {
                  existingUI.remove();
                }

                const commentUI = createCommentUI(
                  comment,
                  extension,
                  view,
                  this.getState(state).comments,
                  extension.options.handleSave
                );
                document.body.appendChild(commentUI);

                const rect = event.target.getBoundingClientRect();
                commentUI.style.position = "fixed";
                commentUI.style.left = `${rect.right + 10}px`;
                commentUI.style.top = `${rect.top}px`;
              }
            }
            return false;
          },
        },
      }),
    ];
  },
});

// Updated styles
const style = document.createElement("style");
style.textContent = `
  .selection-highlight {
    background-color: #ffd70066;
    cursor: pointer;
    position: relative; 
  }
  .selection-highlight:hover[data-has-comments="true"]::after {
    content: '💬';
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    background: green;
    border-radius: 50%;
    padding: 2px;
    font-size: 1.2em;
    cursor: pointer;
  }
  
  .selection-highlight.has-comments {
    background-color: #90EE9088;
  }
  
  .add-comment-button {
    cursor: pointer;
    border: none;
    background: none;
    font-size: 1.2em;
    padding: 4px;
  }
  
  .comment-container {
    position: fixed;
    width: 400px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 12px;
    z-index: 999999999;
    top:0 !important;
    left:50% !important;
    transform: translateX(-50%) !important;
  }
  
  .comment-area {
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 12px;
  }
  
  .comment-thread {
    border-bottom: 1px solid #eee;
    padding: 8px 0;
  }
  
  .author-info {
    font-weight: bold;
    margin-bottom: 4px;
  }
  
  .comment-text {
    margin-bottom: 4px;
    white-space: pre-wrap;
  }
  
  .timestamp {
    font-size: 0.8em;
    color: #666;
  }
  
  .comment-input {
    width: 90%;
    min-height: 100px;
    margin-bottom: 8px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    resize: vertical;
  }
  
  .save-comment-button {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .close-comment-button {
    position: absolute;
    right: 8px;
    top: 8px;
    background: none;
    border: none;
    font-size: 1.2em;
    cursor: pointer;
    color: #666;
  }

.resolved-comment-button {
    background: #2196F3;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 8px;
  }
    .accept-comment-button {
    background: #2196F3;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 8px;
  }

  .reject-comment-button {
    background: #F44336;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 8px;
    margin-left: 8px;
    position: absolute;
    right: 10px;
  }
`;
document.head.appendChild(style);

export default SelectionHighlight;
